import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	position: absolute;
	top: 50%;
	right: 80px;
	transform: translateY(-50%);
	width: 340px;
	padding: 27px 30px 30px;
	background-color: rgba(17, 19, 20, 0.98);
	border-radius: 10px;
	border: 1px solid rgba(255, 255, 255, 0.1);
`;

const StyledDivider = styled.div`
	width: 100%;
	height: 1px;
	background-color: rgba(255, 255, 255, 0.1);
`;

const StyledInputsContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 10px;
	margin-top: 20px;
`;

const StyledButtonContainer = styled.div`
	margin-top: 20px;
`;

const StyledPriceContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr auto 16px;
	gap: 10px;
	margin-top: 20px;

	${Text} {
		font-size: 16px;
		color: #ffffff;

		&:nth-child(1) {
			opacity: 0.5;
		}

		&:nth-child(2) {
			font-weight: 700;
		}
	}
`;

const StyledUpdateButtonsContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 10px;
	margin-top: 30px;
`;

const StyledUpdateButtonContent = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	img {
		height: 16px;
		width: 16px;
		user-select: none;
		pointer-events: none;
	}
`;

export {
	StyledButtonContainer,
	StyledContainer,
	StyledDivider,
	StyledInputsContainer,
	StyledPriceContainer,
	StyledUpdateButtonContent,
	StyledUpdateButtonsContainer,
};
